/* eslint-disable */

const OPERATOR_FORMULA_TYPES = new Set(["+", "-", "*", "/"]);

export const getMachineFormula = (machine = {}) => {
  const rawType =
    machine?.Formula?.Type ??
    machine?.FormulaType ??
    machine?.MachineFormulaType ??
    null;
  const type = String(rawType ?? "").trim();
  if (!OPERATOR_FORMULA_TYPES.has(type)) return null;

  return {
    ...(machine?.Formula || {}),
    Id: machine?.Formula?.Id ?? machine?.FormulaId ?? machine?.MachineFormulaId ?? null,
    Type: type,
    Value: machine?.Formula?.Value ?? machine?.FormulaValue ?? machine?.MachineFormulaValue ?? null,
  };
};

export const hasMachineOperatorFormula = (machine = {}) => Boolean(getMachineFormula(machine));
